import { createColumnHelper } from "@tanstack/react-table";
import { getStatusBadge } from "../../component/table-utils/get-status-badge";
import React from "react";
import TableMenu from "../../component/table-utils/tableMenu";
import truncate from "../../lib/utils/truncate";
import formatDate from "../../lib/utils/formatDate";

export type LeadsDataType = {
  _id: string;
  firstname: string;
  lastname?: string;
  company_name: string;
  createdAt: string;
  phone_number: string;
  email: string;
  is_active: boolean;
};
const columnHelper = createColumnHelper<LeadsDataType>();

export const basicColumns = [
  columnHelper.display({
    id: "firstname",
    size: 120,
    header: "FIRST NAME",
    cell: ({ row }) => <>{row.original.firstname}</>,
  }),
  columnHelper.display({
    id: "lastname",
    size: 120,
    header: "LAST NAME",
    cell: ({ row }) => <>{row.original.lastname}</>,
  }),
  columnHelper.display({
    id: "company",
    size: 120,
    header: "COMPANY",
    cell: ({ row }) => <>{row.original.company_name}</>,
  }),
  columnHelper.display({
    id: "phone",
    size: 120,
    header: "PHONE",
    cell: ({ row }) => <>{row.original.phone_number}</>,
  }),
  columnHelper.display({
    id: "email",
    size: 150,
    header: "EMAIL ADDRESS",
    cell: ({ row }) => <>{truncate(row.original.email, 20)}</>,
  }),
  columnHelper.accessor("createdAt", {
    id: "dateandtime",
    size: 200,
    header: ({ column }) => (
      <div className="flex items-center gap-1">DATE AND TIME ADDED</div>
    ),
    cell: (info) => <>{formatDate(info.getValue())}</>,
    enableSorting: true,
  }),

  columnHelper.display({
    id: "appointment",
    size: 110,
    header: "APPOINTMENT",
    cell: ({ row }) => {
      /* const status = row.original.is_active ? "booked" : "not booked";
      return <>{getStatusBadge(status)}</>; */
      return <>N/A</>;
    },
  }),
  columnHelper.display({
    id: "actions",
    size: 30,
    cell: ({ row }) => (
      <div
        className="w-full flex justify-center"
        onClick={(e) => e.stopPropagation()}
      >
        <TableMenu row={row} page="leads" />
      </div>
    ),
  }),
];
